import React from 'react'
import PropTypes from 'prop-types'

class Tick extends React.Component {

  constructor () {
    super ()
  }

  render () {
    const style = {
    }
    return (
      <div
        className="tick-inner"
        style={{ backgroundColor: this.props.color}}>
        <i
          className="fa fa-check"
          aria-hidden="true"
          style={{color:"#fff"}}>
        </i>
      </div>
    )
  }
}

Tick.propTypes = {
  color: PropTypes.string
}

export default Tick;
